/**
 * Popup de confirmação do modal de contato — C-75 (ajuste de 14/10).
 * "Sim" executa; "Não" só fecha o popup e devolve ao modal, com o que foi
 * digitado intacto. Substitui o `window.confirm` (mesmo padrão para salvar e
 * para desativar). Esc = "Não" e o foco volta ao botão que abriu — `usePopup` (C-91).
 */
import { usePopup } from '@/hooks/usePopup';

interface Props {
  titulo: string;
  texto: string;
  onSim: () => void;
  onNao: () => void;
}

export default function ConfirmacaoContato({ titulo, texto, onSim, onNao }: Props) {
  const ref = usePopup<HTMLDivElement>({ aoFechar: onNao });

  return (
    <div className="fixed inset-0 z-[2010] flex items-center justify-center bg-black/50 p-4">
      <div
        ref={ref}
        tabIndex={-1}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="confirmacao-contato-titulo"
        aria-describedby="confirmacao-contato-texto"
        className="w-full max-w-xs rounded-xl border border-jf-border bg-jf-surface p-4 focus:outline-none"
      >
        <h3 id="confirmacao-contato-titulo" className="text-sm font-bold text-white">{titulo}</h3>
        <p id="confirmacao-contato-texto" className="mt-1 text-xs text-jf-muted">{texto}</p>
        <div className="mt-4 flex justify-end gap-2">
          <button
            type="button"
            onClick={onNao}
            autoFocus
            className="rounded-md border border-jf-border px-3 py-1.5 text-xs font-bold text-jf-muted hover:text-white"
          >
            Não
          </button>
          <button
            type="button"
            onClick={onSim}
            className="rounded-md bg-jf-yellow px-3 py-1.5 text-xs font-bold text-jf-bg"
          >
            Sim
          </button>
        </div>
      </div>
    </div>
  );
}
